<template>
    <div class="border bg-gray-100 dark:bg-gray-800 rounded p-4 mt-3">
        <div class="mb-4">Trust Banner</div>
            <div>
                <Select
                    label="* Type"
                    name="type"
                    v-model="data.type"
                    class="mt-2"
                    :options="[
                        {value: 'safety', name: 'Safety banner'},
                        {value: 'featured', name: 'Featured in banner'},
                    ]"
                />
            </div>
            <draggable
                v-model="data.items"
                ghost-class="bg-gray-500"
                handle=".handle"
                @choose="froalaStore.disableFroala = true"
                @unchoose="froalaStore.disableFroala = false"
            >
                <div v-for="(item, index) in data.items"
                    :key="`trustBanner-${item.id || item.uuid}`"
                    class="relative mt-2 max-w-8xl item">
                        <div class="flex mt-3 items-center">
                            <rocket-link
                                :language="language"
                                class="mb-3 pl-5"
                                v-model="item.link"
                                :resettable="true"
                                :hide-link-text="true"
                            />

                            <media-reference
                                :name="`trust_banner_[${index}][logo]`"
                                v-model="item.logo"
                                class="ml-3 pl-5"
                                :media-types="['OperatorLogo', 'PaymentLogo', 'SoftwareLogo', 'LicenseLogo', 'Logo']"
                                @input="updateLogo(index, $event)"
                            />

                            <template v-if="data.items?.length > 1">
                                <div
                                    @click="handleDelete(index)"
                                    class="ml-2 cursor-pointer"
                                >
                                    <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                    </svg>
                                </div>
                                <div class="ml-4 handle" title="Drag to reorder items">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                                    </svg>
                                </div>
                            </template>
                        </div>
                    </div>
                    <button slot="footer"
                        class="mt-6 text-indigo-600 dark:text-indigo-300 hover:text-indigo-900 dark:hover:text-indigo-200"
                        type="button"
                        v-if="( data.type == 'featured' ) || ( data.type == 'safety' && data.items?.length < maxItems )"
                        @click="addItem"
                    >
                        + Add item
                    </button>
            </draggable>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import siteLanguage from '../../config/siteLanguage';
import {useFroalaStore} from "../../stores/froala";
import {v4 as uuidv4} from "uuid";

export default {
    components: { draggable },
    name: "TrustBanner",
    props: {
        value: [Object, Array],
        contentBlockId: Number,
        contentSectionId: Number,
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
    },
    data() {
        return {
            maxItems: 7,
            data: this.value?.id ? this.value : this.defaultData(),
            froalaStore: useFroalaStore(),
        };
    },
    updated() {
        this.$emit("input", this.data);
    },
    methods: {
        defaultData() {
            return {
                type: "safety",
                items: [this.defaultItem()],
            }
        },
        defaultItem() {
            return {
                uuid: uuidv4(),
                link: {},
                logo: null,
                logo_id: null,
            }
        },
        addItem(e) {
            e.preventDefault();
            this.data['items'].push(this.defaultItem());
        },
        handleDelete: function (indexOfItemToDelete) {
            if (confirm('Are you sure you want to remove this item?')) {
                this.data['items'].splice(indexOfItemToDelete, 1);
            }
        },
        updateLogo: function (index, logo) {
            this.data['items'][index].logo_id = (logo && logo.id) ? logo.id : null;
        },
    },
    watch: {
        value: function (newValue) {
            this.data = newValue;
        }
    }
};
</script>
